import { suppliosApi } from "@/js/api-service";

const cacheAsync = {}
let timeoutAsync = null

// WARNING: only works with vendors, see comment below.
const uniqueAsync = async ({ name, value, getFormValues }, type) => {
  if (!value || value === '') {
      return true
  }

  value = value.toLowerCase()
  const cacheKey = `${type}_${value}`

  let results = cacheAsync[cacheKey]
  
  if (!results) {
    if (timeoutAsync) {
      clearTimeout(timeoutAsync)
    }

    results = cacheAsync[cacheKey] = await new Promise(resolve => {
      timeoutAsync = setTimeout(async () => {
        // TODO: this should be replaced with a more generic endpoint name for all resources, e.g. /validations/vendors/is-:field-unique/:value that returns a boolean
        const apiMethod = `${type}Search`;
        const response = await suppliosApi["internal"][apiMethod](value);
        resolve(response.data)
      }, 300)
    })
  }

  const { id } = getFormValues();
  if (id && id !== '') {
    results = results.filter((result) => result.id != id)
  }
  
  const result = results?.find(result => {
    if (typeof result === 'object') {
      return result[name].toLowerCase() == value
    }

    return result.toLowerCase() === value
  })

  return !result
}

const uniqueAsyncMessage = ({ name, args }) => {
  const type = args[0];
  return `A ${type} already exists with this ${name}.`;
}

export default {
  rules: { uniqueAsync },
  messages: {
    uniqueAsync: uniqueAsyncMessage,
  }
}